import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

export const styles = StyleSheet.create({
  counterWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 30
  },
  EmergencyLozenge: {
    color: '#ffffff',
    background: colour.brand.red,
    fontSize: 16,
    fontWeight: 700,
    textAlign: 'center',
    borderRadius: 30,
    padding: '10px 4%',
    margin: '0 5px',
    flexGrow: 1,
    flexWrap: 'nowrap',
    maxWidth: 180,
    cursor: 'pointer',
    textDecoration: 'none'
  },
  WarningLozenge: {
    color: '#000000',
    background: colour.assisted.primaryGradientTop,
    fontSize: 16,
    fontWeight: 700,
    textAlign: 'center',
    borderRadius: 30,
    padding: '10px 4%',
    margin: '0 5px',
    flexGrow: 1,
    flexWrap: 'nowrap',
    maxWidth: 180,
    cursor: 'pointer',
    textDecoration: 'none'
  },
  EmergencyNumber: {
    fontSize: 16,
    fontWeight: 600,
    padding: 3,
    marginRight: 5,
    display: 'inline-block',
    width: 30,
    height: 30,
    textAlign: 'center',
    border: '1px solid #ffffff',
    borderRadius: '50%'
  },
  WarningNumber: {
    fontSize: 16,
    fontWeight: 600,
    padding: 3,
    marginRight: 5,
    display: 'inline-block',
    width: 30,
    height: 30,
    textAlign: 'center',
    border: '1px solid #000000',
    borderRadius: '50%'
  }
});
